﻿export type GroupKey =
  | 'All Groups'
  | 'Accounting Group A'
  | 'Accounting Group B'
  | 'Accounting Group C'
  | 'Accounting Group D';
export const GroupMapping: Record<GroupKey, string> = {
  'All Groups': '',
  'Accounting Group A': '2',
  'Accounting Group B': '3',
  'Accounting Group C': '4',
  'Accounting Group D': '5',
};
